<div class="wrapper">
  @if (isContactFormValid()) {
    @if (contactsDialogData().fromBloggerProfile) {
      <div class="contacts-container">
        <mat-accordion [multi]="true">
        @for (contact of contactFormGroups(); track $index) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                ФИО: {{ contact.get('fio')?.value }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div
              class="contacts-form"
              app-form-contacts-modal
              [contactFormGroup]="contact"
              [contactData]="contactsData()[$index]"
              [contactsDialogData]="contactsDialogData()"
              [telegramAccountIds]="telegramAccountIds()"
              [currentContactIndex]="$index"
              [isEditModeActive]="isEditModeActive()"
              (handleUpdateData)="handleUpdateData($event, $index)"
              (deleteContactClick)="handleDeleteOrUnbind($event)"
            ></div>
          </mat-expansion-panel>
        }
        </mat-accordion>
      </div>
    } @else {
      <div class="contact-unbind">
        <app-action-dropdown-menu
          [actionsList]="['UNBIND_CONTACT']"
          (actionSelected)="handleDeleteOrUnbind()"
        />
      </div>
      <div class="form-wrapper">
        <div
          app-form-contacts-modal
          [contactFormGroup]="contactFormGroups()[0]"
          [contactData]="contactsData()[0]"
          [contactsDialogData]="contactsDialogData()"
          [telegramAccountIds]="telegramAccountIds()"
          [isEditModeActive]="isEditModeActive()"
          (handleUpdateData)="handleUpdateData($event, 0)"
        ></div>
      </div>
    }
  } @else {
    <app-loader/>
  }
</div>
<div class="buttons-container">
  <button
    mat-button
    color="warn"
    (click)="closeDialog.emit('cancel')"
  >
    Закрыть
  </button>
</div>
